import { render, staticRenderFns } from "./PopinNotification.vue?vue&type=template&id=e18d5bc4"
import script from "./PopinNotification.vue?vue&type=script&lang=js"
export * from "./PopinNotification.vue?vue&type=script&lang=js"
import style0 from "./PopinNotification.vue?vue&type=style&index=0&id=e18d5bc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports